import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultant-routable.tsx
var LazyConsultantRoutable = lazy(() => import("./consultant-routable-EkMoaI8v.js").then((n) => n.n).then((module) => ({ default: module.ConsultantRoutable })));
function ConsultantRoutable({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultant-routable" }),
		children: /* @__PURE__ */ jsx(LazyConsultantRoutable, { ...props })
	});
}
var useConsultantRoutable = () => {
	return useMemo(() => ({ consultant: { component: ConsultantRoutable } }), []);
};
//#endregion
export { useConsultantRoutable };
